/**
 * 缓存类
 */
import * as Tools from './tools'


const tag = 'gjkc_';

/**
 * 存储
 * @param key
 * @param data
 */
export const set = function (key, data) {
    return localStorage.setItem(tag+key, Tools.jsonEncode(data));
}
/**
 * 获取
 * @param key
 */
export const get = function (key) {
    return Tools.jsonDecode(localStorage.getItem(tag+key));
}
/**
 * 移除缓存
 * @param key
 */
export const remove = function (key) {
    return localStorage.removeItem(tag+key);
}
/**
 * 清空全部缓存
 */
export const clear = function () {
    return localStorage.clear();
}
